import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/xtorageFile'

export const xtorageFileService = {
    search,
    getItem,
    saveItem,
    updateItem,
    deleteItem,
};

function search(data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search`, 'POST', { data:data, showAlert:false })
}

function getItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'GET',{ showAlert:false })
}

function saveItem(data) {
    return utilHelper.doRequestFileHandleResponse(`${relativeUrl}`, 'POST', data);
}

function updateItem(id, data) {
    return utilHelper.doRequestFileHandleResponse(`${relativeUrl}/${id}`, 'PUT', data);
}

function deleteItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'DELETE',{})
}